import request from '@/utils/request.js'
import qs from 'qs';

export function getAccountListPage(data){
    return request({
        url: 'agent/listPage',
        method: 'post',
        data
    })
}
export function exportOrderInfo(data){
    return request({
        url: 'export/agentPrice',
        method: 'post',
        data
    })
}
export function getAgentAccountListPage(data){
    return request({
        url: 'agent/collect/listPage',
        method: 'post',
        data
    })
}

export function getImportFailRecordList(data){
    return request({
        url: 'agent/listPage/price',
        method: 'post',
        data
    })
}



export function changeCashbackState(data){
    return request({
        url: 'agent/isCashback',
        method: 'post',
        data
    })
}
/***新增代理商***/
export function addNewAgent(data){    
    return request({
        url: 'agent/add',
        method: 'post',
        data
    })
}
/***修改代理商信息***/
export function updateAgentInfo(data){    
    return request({
        url: 'agent/update/up',
        method: 'post',
        data
    })
}

export function getAgentListOption(data){
    return request({
        url: 'agent/list',
        method: 'post',
        data
    })
}
export function getAgentListOptions(data){
    return request({
        url: 'yewu/all/yewus',
        method: 'post',
        data
    })
}
export function getAgentListOption1(data){
    return request({
        url: 'agent/list/list',
        method: 'post',
        data
    })
}

export function getAgentList(data){
    return request({
        url: 'agent/account/next/list',
        method: 'post',
        data
    })
}
/***查询秒返开关***/
export function getSecondBackInfo(data){
    return request({
        url: 'sysConfig/back/query',
        method: 'post',
        data
    })
}
/***设置秒返开关***/
export function updateSecondBackState(data){
    return request({
        url: 'sysConfig/back/update',
        method: 'post',
        data
    })
}
/***查询手机绑定***/
export function getBindPhoneInfo(data){
    return request({
        url: 'bindPhone/pc/state',
        method: 'get',
        data
    })
}
/***设置手机绑定***/
export function updateBindPhoneState(data){
    return request({
        url: 'bindPhone/update',
        method: 'post',
        data
    })
}

//秒返设置（一键诊断设置）
export function secondBackDiagnose(data){
    return request({
        url: 'sysConfig/diagnose',
        method: 'post',
        data
    })
}


//查询秒返设置 
export function querySecondBack(data){
    return request({
        url: 'sysConfig/diagnose/query',
        method: 'post',
        data
    })
}

//查询优惠券配置 
export function querySysConfigCoupon(data){
    return request({
        url: 'sysConfig/coupon/query',
        method: 'get',
        data
    })
}

/***更新优厚券配置***/
export function updateSysConfigCoupon(data){
    return request({
        url: 'sysConfig/coupon/update',
        method: 'post',
        data
    })
}

/**
 * 查询优惠券信息
 */
export function queryCouponList(data){
    return request({
        url: 'flowCoupon',
        method: 'post',
        data
    })
}

/**  根据登录账号查询代理商信息   **/
export function selectAgentByAccountName(data){
    return request({
        url: 'agent/select/byAccountName',
        method: 'post',
        data
    })
}


/**  代理商层级关系迁移记录列表   **/
export function getAgentChangeList(data){
    return request({
        url: 'agent/relation/change/listPage',
        method: 'post',
        data
    })
}


/**  代理商层级关系迁移操作   **/
export function doAgentChange(data){
    return request({
        url: 'agent/relation/change',
        method: 'post',
        data
    })
}


/**  代理商收款配置   **/
export function collectionConfig(data){
    return request({
        url: 'agent/collectConfig/add',
        method: 'post',
        data
    })
}


/****** 下级客户账号导出 ********/
export function exportCollectAgentList(data){
    return request({
        url: 'export/collectAgentList',
        method: 'post',
        data
    })
}



/**  总部收款配置   **/
export function adminCollectionConfig(data){
    return request({
        url: 'agent/collectConfig/admin',
        method: 'post',
        data
    })
}

/**  查询代理商收款配置   **/
export function selectCollectionConfig(data){
    return request({
        url: 'agent/collectConfig/agent/select',
        method: 'post',
        data
    })
}

/**  查询总部微信收款配置   **/
export function selectAdminCollectionConfig(data){
    return request({
        url: 'agent/collectConfig/admin/select',
        method: 'post',
        data
    })
}



/**  添加/编辑乐刷代理商收款配置   **/
export function addLsCollectionConfig(data){
    return request({
        url: 'agent/collectConfig/ls/add',
        method: 'post',
        data
    })
}

/**  查询乐刷代理商收款配置   **/
export function selectLsCollectionConfig(data){
    return request({
        url: 'agent/collectConfig/ls/query',
        method: 'post',
        data
    })
}
